import api from '@/api';

const { $pricing, $academic, $student } = api;

export const { $types } = $pricing;
export const { $products } = $pricing;
export const { $terms } = $academic;
export const { $tools } = $student;

